export default __webpack_public_path__ + "static/media/Koruri-Regular.a0309f27.ttf";